import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userData: 'loading',
    mode: 'client',
    quotationOnly: false,
    clientMode: false,
    introducerId: '',
    background: '',
    logo: null,
    hidePrice: false,
    colours: {
      base: null,
      hover: null
    },
    formData: {
      businessName: '',
      companyType: '',
      postcode: '',
      companyReg: '',
      sector: 'Please select an industry sector',
      turnover: null,
      homeOwners: null,
      yearsTrading: 'Number of years trading',
      customers: null,
      creditControl: null
    },
    contact: {
      name: '',
      number: '',
      email: ''
    },
    companyData: {}
  },
  mutations: {
    setFormData(state, data) {
      for (let key in data) {
        Vue.set(state.formData, key, data[key])
      }
    },
    setCompanyData(state, data) {
      Vue.set(state, 'companyData', data)
    },
    setContact(state, data) {
      state.contact = data
    }
  },
  actions: {
    setContact(context, data) {
      context.commit('setContact', data)
    },
    setCompanyData(context, data) {
      context.commit('setCompanyData', data)
    },
    setFormData(context, data) {
      context.commit('setFormData', data)
    },
    clearForm(context) {
      context.commit('setFormData', {
        businessName: '',
        companyReg: '',
        sector: 'Please select an industry sector',
        turnover: null,
        homeOwners: null,
        yearsTrading: 'Number of years trading',
        customers: null,
        creditControl: null
      })
    }
  },
  modules: {
  }
})
